import { Navigate } from "react-router-dom";

/**
 * Legacy ApplyPage — Climate Power Summit 2026 now has its dedicated
 * branded application/payment flow. Any generic /apply route lands here
 * and is redirected to the CPS page.
 *
 * The prior generic $15.99 registration form is intentionally not shown
 * for CPS applicants — see /apply/cps-2026 (CpsApplyPage) for the live
 * India ₹500 / International $10 experience.
 */
export default function ApplyPage() {
    return <Navigate to="/apply/cps-2026" replace />;
}
